var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurecooldown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20.8477 28.5117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 28.5117,
    opacity: 0,
    width: 20.8477,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.92188 8.84766C6.32812 8.84766 7.46484 7.71094 7.46484 6.28125C7.46484 4.875 6.32812 3.73828 4.92188 3.73828C3.50391 3.73828 2.35547 4.875 2.35547 6.28125C2.35547 7.71094 3.50391 8.84766 4.92188 8.84766ZM11.3086 21.1172L14.9414 16.125L17.2383 20.3203C18.0117 23.918 18.1055 26.6719 18.1055 27.0938C18.1055 27.8203 18.6445 28.3594 19.3008 28.3594C19.9805 28.3594 20.4961 27.8203 20.4961 27.1289C20.4961 27.0117 20.4375 23.8711 19.582 19.6523L19.5352 19.4414C18.5508 14.6016 15.4688 5.64844 7.51172 0.363281C7.11328 0.117188 6.76172 0 6.35156 0L1.19531 0C0.539062 0 0 0.539062 0 1.19531C0 1.88672 0.539062 2.42578 1.19531 2.42578L6.25781 2.42578C7.51172 3.29297 8.60156 4.23047 9.59766 5.23828C9.73828 5.36719 9.75 5.57812 9.65625 5.73047L5.60156 12.6562C5.10938 13.5234 5.70703 14.4727 6.64453 14.4727L12.1758 14.4727L9.26953 19.8164L9.15234 20.0273L5.57812 26.5664C5.25 27.1523 5.46094 27.9023 6.04688 28.207C6.59766 28.5 7.34766 28.3711 7.69922 27.7266ZM8.73047 12.0703L9.63281 10.5352C9.77344 10.2656 10.0547 10.3242 10.1719 10.5L11.2266 12.0703Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurecooldown);
export default __webpack_public_path__ + "static/media/figure.cooldown.b84b6a7d41cc563f2a3500be7e45707f.svg";
export { ForwardRef as ReactComponent };